export default {
    cpmcpc: 'CPM/CPC',
    cpm: 'CPM',
    agencyMargin: 'Agency Margin',
    totalSpendMarkup: 'Total Cost Markup',
    disabled: 'Disabled',
};
